// Anavir footer — inject SVG logo if no image has been uploaded yet
(function () {
  var svgLogo = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375 155" style="width:130px;height:auto;display:block;fill:#000;"><g><polygon points="25.49,12.15 3.29,12.15 3.29,152.15 25.49,152.15 35.69,152.15 96.09,152.15 96.09,124.35 35.69,124.35 35.69,92.35 92.09,92.35 92.09,64.75 35.69,64.75 35.69,39.95 96.09,39.95 96.09,12.15 35.69,12.15"></polygon><rect x="119.89" y="12.15" width="34.2" height="140"></rect><rect x="179.89" y="12.15" width="34.2" height="140"></rect><path d="M333.49,152.15h38.6l-73.4-148.8l-73.8,148.8h38.2l13.05-27h44.33L333.49,152.15z M314.19,99.35h-31.17l15.66-35.6 L314.19,99.35z"></path></g></svg>';

  function init() {
    var footer = document.querySelector('.section-footer');
    if (!footer) return;

    // Find the image block in the info column (first column)
    var imgBlock = footer.querySelector('.image-block');
    if (!imgBlock) return;

    // Check if a real image exists — if so, leave it alone
    var realImg = imgBlock.querySelector('img:not(.placeholder-svg)');
    if (realImg && realImg.src && !realImg.src.includes('data:')) return;

    // Check if placeholder SVG is showing — replace with our logo
    var placeholder = imgBlock.querySelector('.placeholder-svg, svg');
    if (!placeholder) return;

    var link = document.createElement('a');
    link.href = '/';
    link.setAttribute('aria-label', 'Anavir home');
    link.innerHTML = svgLogo;
    link.style.display = 'block';

    // Replace the placeholder with the logo link
    placeholder.parentElement.insertBefore(link, placeholder);
    placeholder.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
